import { pricingConfig } from "../form/formConfig";

/**
 * Calculate the price of a carport configuration
 * This function dynamically calculates the price based on the pricing rules
 * defined in the formConfig.js
 *
 * @param {Object} formValues - The form values from the configurator
 * @returns {number} - The total calculated price
 */
export const calculate_carport_price = (formValues) => {
  let totalPrice = pricingConfig.basePrice;
  const priceBreakdown = {
    base: pricingConfig.basePrice,
    details: []
  };

  // Iterate through each price rule and calculate the contribution
  Object.keys(pricingConfig.priceRules).forEach(fieldName => {
    const rule = pricingConfig.priceRules[fieldName];
    const value = formValues[fieldName];

    if (value !== undefined && value !== null) {
      let contribution = 0;

      switch (rule.type) {
        case 'linear':
          contribution = rule.formula(value, rule.baseValue, rule.pricePerUnit);
          break;

        case 'perUnit':
          contribution = rule.formula(value, rule.pricePerUnit);
          break;

        case 'materialPrice':
          contribution = rule.formula(value, rule.prices);
          break;

        case 'colorPrice':
          contribution = rule.formula(value, rule.prices);
          break;

        default:
          contribution = 0;
      }

      totalPrice += contribution;

      if (contribution !== 0) {
        priceBreakdown.details.push({
          field: fieldName,
          contribution: contribution,
          value: value
        });
      }
    }
  });

  console.log('💰 Price Breakdown:', priceBreakdown);
  console.log('💰 Total Price:', totalPrice);

  return Math.max(0, totalPrice); // Ensure price is never negative
}

/**
 * Calculate total price for multiple orders (legacy function for compatibility)
 * For the carport configurator, we typically have a single configuration
 */
export const calculate_total_price = (formValues) => {
  // If formValues is an array (legacy), calculate sum
  if (Array.isArray(formValues)) {
    return formValues.reduce((total, order) => total + (order.prijs || 0), 0);
  }

  // Otherwise, calculate price for single carport configuration
  return calculate_carport_price(formValues);
}

/**
 * Legacy function for backward compatibility
 * Maps old order format to new carport pricing
 */
export const calculate_price = (order) => {
  const price = calculate_carport_price(order);
  return { ...order, prijs: price };
}

const roundToNearest = (value, availableSizes) => {
    // Converteer de keys naar getallen en zoek de dichtstbijzijnde
    const sizes = availableSizes.map(Number);
    return sizes.reduce((nearest, size) => 
      Math.abs(size - value) < Math.abs(nearest - value) ? size : nearest, sizes[0]);
  }
  